import { Color3 } from "@babylonjs/core";
import F1 from "assets/ModelIcons/F1Old.jpg";
import F2 from "assets/ModelIcons/F2Old.jpg";
import F3 from "assets/ModelIcons/F3.jpg";
import M1 from "assets/ModelIcons/M1.jpg";
import { GENDER } from "utils/constants";

export const RENDERER_CONFIG = {
  HDR_LIGHT_ENV: "/environment/Adidas1_Flip/",
  SHADOW_DARKNESS: 0, //Shadow darkness (0.0 = dark shadow, 1.0 = No shadow)
  IS_PLAY_ANIMATIONS_ENABLED: false,
  IS_HDR_ENV_ENABLED: true,
  IS_SPOT_LIGHT_ENABLED: true,
  // ---------------------#####  HEAD  #####----------------------------------------
  // DYNAMIC_HEAD_MODEL_FILE_NAME: "avatarMale.glb",
  DYNAMIC_HEAD_MODEL_FILE_NAME: "default_male.glb",
  DYNAMIC_HEAD_MODEL_FEMALE: "draco_default_female_1.glb",
  ASSETVIEWER_HEAD_MODEL_FILE_NAME: "draco_avatarMale_PompadourHair2.glb",
  ASSETVIEWER_HEAD_MODEL_MALE_LARGE: "larger_head_4.glb",
  ASSETVIEWER_HEAD_MODEL_FEMALE: "draco_avatarFemale_LooseHair4.glb",
  DRACO_HEAD_MATERIAL_NAME: "material0",
  HEAD_MATERIAL_NAME: "material3",
  HEAD_TEXTURE_NAME: "GLTF2/Texture/BS_test_01_img1.jpg",
  HAIR_MATERIAL_NAME: "hair_mat",
  DYNAMIC_HAIR_TEXTURE_NAME: "GLTF2/Texture/BS_test_01_img0.png",

  // ---------------------#####  BODY  #####-----------------------------------------
  DYNAMIC_BODY_MODEL_FILE_NAME: "female_avatar_04.gltf",
  UPPER_BODY_MESHES: ["l_hand_geo", "r_hand_geo", "spine_geo"],
  UPPER_BODY_MORPHS: ["upper_l_hand_bs", "upper_r_hand_bs", "upper_spine_bs"],
  MID_BODY_MESHES: ["spine_geo"],
  MID_BODY_MORPHS: ["middle_spine_bs"],
  LOWER_BODY_MESHES: ["l_leg_geo", "r_leg_geo", "spine_geo"],
  LOWER_BODY_MORPHS: ["lower_l_leg_bs", "lower_r_leg_bs", "lower_pine_bs"],
  BODY_MATERIAL_NAME: "body_mat",
  DYNAMIC_BODY_TEXTURE_NAME: "GLTF2/Texture/BS_test_01_img1.jpg",

  // ---------------------#####   CLOTH   #####--------------------------------------------
  DYNAMIC_CLOTH_MODEL_FILE_NAME: "female_grey_dress_01.gltf",
  CLOTH_MESH: ["grey_skirt_geo"],
  UPPER_CLOTH_MORPHS: ["upper_cloth_bs"],
  MID_CLOTH_MORPHS: ["middle_cloth_bs"],
  LOWER_CLOTH_MORPHS: ["lower_cloth_bs"],
  CLOTH_MATERIAL_NAME: "cloth_mat",
  CLOTH_MATERIAL_BASE_COLOR: Color3.FromInts(128, 128, 128), //set only for grey dress (needs to come from DB)
  DYNAMIC_CLOTH_TEXTURE_NAME: "GLTF2/DressTexture/Grey/Cloth_Diff.jpg",
  DYNAMIC_CLOTH_BUMPS_TEXTURE_NAME: "GLTF2/DressTexture/Grey/Cloth_Nrml.jpg",
  DYNAMIC_CLOTH_ROUGHNESS_TEXTURE_NAME:
    "GLTF2/DressTexture/Grey/Cloth_Spec.jpg",
  // --------------------##### SCALE-INFLUENCE #####----------------------------------------
  DYNAMIC_UPPER_MORPH_INFLUENCE: 0.0, //Influence for morph target (0.0 = no influence, 1.0 = full influence))
  DYNAMIC_MID_MORPH_INFLUENCE: 0.0,
  DYNAMIC_LOWER_MORPH_INFLUENCE: 0.0,
  // ---------------------------------
};

export const CLOTHES = {
  0: {
    DYNAMIC_LOWER_BODY_CLOTH_MODEL_FILE_NAME: "necklace2.glb",
    DYNAMIC_CLOTH_MODEL_FILE_NAME: "female_red_dress_01.gltf",
    DYNAMIC_CLOTH_MESH: ["red_skirt_geo"],
    DYNAMIC_CLOTH_TEXTURE_NAME: "GLTF2/DressTexture/Red/Cloth_Diff.jpg",
    DYNAMIC_CLOTH_BUMPS_TEXTURE_NAME: "GLTF2/DressTexture/Red/Cloth_Nrml.jpg",
    DYNAMIC_CLOTH_ROUGHNESS_TEXTURE_NAME:
      "GLTF2/DressTexture/Red/Cloth_Spec.jpg",
    DYNAMIC_CLOTH_BASE_COLOR: Color3.FromInts(255, 26, 92),
    DYNAMIC_CLOTH_MAT_TYPE: "velvet",
    DYNAMIC_CLOTH_ROUGHNESS: 1,
    DYNAMIC_CLOTH_METALLIC: 0,
    DYNAMIC_CLOTH_ENV_INTENSITY: 0.5,
    DYNAMIC_ENV_NAME: "environment/studio_environment.env",
    DYNAMIC_HANDS_POSITION: "down",
  },
  1: {
    DYNAMIC_LOWER_BODY_CLOTH_MODEL_FILE_NAME: "necklace2.glb",
    DYNAMIC_CLOTH_MODEL_FILE_NAME: "female_pink_dress_01.gltf",
    DYNAMIC_CLOTH_MESH: ["pink_skirt_geo"],
    DYNAMIC_CLOTH_TEXTURE_NAME: "GLTF2/DressTexture/LightPink/Cloth_Diff2.jpg",
    DYNAMIC_CLOTH_BUMPS_TEXTURE_NAME:
      "GLTF2/DressTexture/LightPink/Cloth_Nrml.jpg",
    DYNAMIC_CLOTH_ROUGHNESS_TEXTURE_NAME:
      "GLTF2/DressTexture/LightPink/Cloth_Spec.jpg",
    DYNAMIC_CLOTH_BASE_COLOR: Color3.FromHexString("#DFB8B6"),
    DYNAMIC_CLOTH_ROUGHNESS: 1,
    DYNAMIC_CLOTH_METALLIC: 0,
    DYNAMIC_CLOTH_ENV_INTENSITY: 0.8,
    DYNAMIC_ENV_NAME: "environment/studio_environment.env",
    DYNAMIC_CLOTH_MAT_TYPE: "lux-chiffon",
    DYNAMIC_HANDS_POSITION: "raised",
  },
  2: {
    DYNAMIC_LOWER_BODY_CLOTH_MODEL_FILE_NAME: "necklace2.glb",
    DYNAMIC_CLOTH_MODEL_FILE_NAME: "female_grey_dress_01.gltf",
    DYNAMIC_CLOTH_MESH: ["grey_skirt_geo"],
    DYNAMIC_CLOTH_TEXTURE_NAME: "GLTF2/DressTexture/Grey/Cloth_Diff2.jpg",
    DYNAMIC_CLOTH_BUMPS_TEXTURE_NAME: "GLTF2/DressTexture/Grey/Cloth_Nrml.jpg",
    DYNAMIC_CLOTH_ROUGHNESS_TEXTURE_NAME:
      "GLTF2/DressTexture/Grey/Cloth_Spec.jpg",
    DYNAMIC_CLOTH_BASE_COLOR: Color3.FromInts(128, 129, 125),
    DYNAMIC_CLOTH_ROUGHNESS: 1,
    DYNAMIC_CLOTH_METALLIC: 0,
    DYNAMIC_CLOTH_ENV_INTENSITY: 0.9,
    DYNAMIC_ENV_NAME: "environment/studio_environment.env",
    DYNAMIC_CLOTH_MAT_TYPE: "matte-satin",
    DYNAMIC_HANDS_POSITION: "raised",
  },
  3: {
    DYNAMIC_CLOTH_MODEL_FILE_NAME: "saree.glb",
    DYNAMIC_LOWER_BODY_CLOTH_MODEL_FILE_NAME: "necklace.glb",
    DYNAMIC_CLOTH_MESH: ["geo_M_saree"],
    DYNAMIC_CLOTH_TEXTURE_NAME:
      "female_hourglass_dress_02/female_hourglass_dress_02_L/tShirt/textures_fbx/dress_L_female_t-shirt_diffuse.jpg",
    DYNAMIC_CLOTH_BUMPS_TEXTURE_NAME:
      "female_hourglass_dress_02/female_hourglass_dress_02_L/tShirt/textures_fbx/dress_L_female_t-shirt_normal.jpg",
    DYNAMIC_CLOTH_ROUGHNESS_TEXTURE_NAME:
      "public/female_hourglass_dress_02/female_hourglass_dress_02_L/tShirt/textures_fbx/dress_L_female_t-shirt_roughness.jpg",
    DYNAMIC_CLOTH_BASE_COLOR: Color3.FromInts(255, 26, 92),
    DYNAMIC_CLOTH_MAT_TYPE: "velvet",
    DYNAMIC_CLOTH_ROUGHNESS: 1,
    DYNAMIC_CLOTH_METALLIC: 1,
    DYNAMIC_CLOTH_ENV_INTENSITY: 5,
    DYNAMIC_ENV_NAME: "environment/studio_environment.env",
    DYNAMIC_HANDS_POSITION: "down",
    DYNAMIC_BODY_MODEL_FILE_NAME: "body.glb",
    BODY_MATERIAL_NAME: "geo_M_tShirt",
    DYNAMIC_BODY_TEXTURE_NAME: "GLTF2/Texture/BS_test_01_img1.jpg",
    CLOTH_MATERIAL_NAME: "dress_M_female_tshirt",
  },
};

//Measurements
export const MEASUREMENTS = {
  female: {
    default: {
      height: 168,
      weight: 60,
      chest: 96,
      waist: 76,
      hip: 105,
    },
    max: {
      height: 168,
      weight: 125,
      chest: 140,
      waist: 122,
      hip: 145,
    },
  },
  male: {
    default: {
      height: 179,
      weight: 62,
      chest: 96,
      waist: 76,
      hip: 105,
    },
    max: {
      height: 188,
      weight: 215,
      chest: 150,
      waist: 140,
      hip: 140,
    },
  },
};

export const BODY_TYPES = {
  RECTANGLE: "rectangle",
  INV_TRIANGLE: "inverted_triangle",
  TRIANGLE: "triangle",
  SPOON: "spoon",
  HOURGLASS: "hourglass",
  APPLE: "apple",
};

export const CUP_TYPES = {
  BC: "BC",
  CD: "CD",
  DDD: "DDD",
};

export const CUP_IDENTIFIER = {
  0: CUP_TYPES.BC,
  1: CUP_TYPES.CD,
  2: CUP_TYPES.DDD,
};

export const SHAPE_TYPES = {
  Apple: "apple",
  Pear: "pear",
  Lemon: "lemon",
};

export const SHAPE_IDENTIFIER = {
  0: SHAPE_TYPES.Apple,
  1: SHAPE_TYPES.Pear,
  2: SHAPE_TYPES.Lemon,
};

export const POSITION_TYPES = {
  NARROW: "narrow",
  REGULAR: "regular",
  WIDE: "wide",
};

export const POSITION_IDENTIFIER = {
  0: POSITION_TYPES.NARROW,
  1: POSITION_TYPES.REGULAR,
  2: POSITION_TYPES.WIDE,
};

export const BODY_IDENTIFIER = {
  0: BODY_TYPES.RECTANGLE,
  1: BODY_TYPES.INV_TRIANGLE,
  2: BODY_TYPES.TRIANGLE,
  3: BODY_TYPES.SPOON,
  4: BODY_TYPES.HOURGLASS,
};

export const DEFAULT_AVATARS = {
  [GENDER.FEMALE]: [
    {
      url: "https://public-hs-v1.s3.eu-west-3.amazonaws.com/default/default_female_1.jpg",
      type: "image",
      value: "default_female_1",
    },
    {
      url: "https://public-hs-v1.s3.eu-west-3.amazonaws.com/default/default_female_2.jpg",
      type: "image",
      value: "default_female_2",
    },
    {
      url: "https://public-hs-v1.s3.eu-west-3.amazonaws.com/default/default_female_3.jpg",
      type: "image",
      value: "default_female_3",
    },
    {
      url: "https://public-hs-v1.s3.eu-west-3.amazonaws.com/default/default_female_4.jpg",
      type: "image",
      value: "default_female_4",
    },
  ],
  [GENDER.MALE]: [
    {
      url: "https://public-hs-v1.s3.eu-west-3.amazonaws.com/default/default_male_1.jpg",
      type: "image",
      value: "default_male_1",
    },
    {
      url: "https://public-hs-v1.s3.eu-west-3.amazonaws.com/default/default_male_2.jpg",
      type: "image",
      value: "default_male_2",
    },
    {
      url: "https://public-hs-v1.s3.eu-west-3.amazonaws.com/default/default_male_3.jpg",
      type: "image",
      value: "default_male_3",
    },
    {
      url: "https://public-hs-v1.s3.eu-west-3.amazonaws.com/default/default_male_4.jpg",
      type: "image",
      value: "default_male_4",
    },
    {
      url: "https://public-hs-v1.s3.eu-west-3.amazonaws.com/default/default_male_5.jpg",
      type: "image",
      value: "default_male_5",
    },
  ],
};

export const CAMERA_TYPE = {
  BODY: "Body",
  TOP: "Top",
  BOTTOM: "Bottom",
  SHOES: "Shoes",
  HEATMAP_TOP: "HeatmapTop",
  HEATMAP_BOTTOM: "HeatmapBottom",
  WELCOME_SCREEN: "WelcomeScreen",
  FACE_SELECTION: "FaceSelection",
  FACE_SELECTION_FEMALE: "FaceSelectionFemale",
  VIEW_MODE: "ViewMode",
};

export const CAMERA_MODE = {
  [CAMERA_TYPE.BODY]: {
    alpha: 0.966,
    beta: 1.5395,
    radius: 2.75,
    fov: 0.9,
    target: { x: 0.0, y: 0.55, z: 0.0 },
    modelTarget: "0m 0.5669154826845573m 0.040044080220377865m",
    modelOrbit:
      "-0.44612930167853104rad 1.558409809407251rad 6.023443267548204m",
    modelFov: "24.858deg",
    maxCameraOrbit: "auto 120deg 7m",
    type: CAMERA_TYPE.BODY,
  },
  [CAMERA_TYPE.VIEW_MODE]: {
    alpha: 0.966,
    beta: 1.5395,
    radius: 2.75,
    fov: 0.75,
    target: { x: 0.0, y: 0.8, z: 0.0 },
    modelTarget: "0m 0.7735834104252942m 0.06975804140906305m",
    modelOrbit: "-0.4388986433391576rad 1.58733133947909rad 5.341333961205822m",
    modelFov: "23.0699deg",
    maxCameraOrbit: "auto 120deg 7m",
    type: CAMERA_TYPE.VIEW_MODE,
  },
  [CAMERA_TYPE.WELCOME_SCREEN]: {
    alpha: 0.966,
    beta: 1.5395,
    radius: 2.75,
    fov: 0.9,
    target: { x: 0.0, y: 0.55, z: 0.0 },
    modelTarget: "0m 0.5669154826845573m 0.040044080220377865m",
    modelOrbit:
      "-0.44612930167853104rad 1.558409809407251rad 6.023443267548204m",
    modelFov: "24.858deg",
    maxCameraOrbit: "auto 120deg 7m",
    type: CAMERA_TYPE.WELCOME_SCREEN,
  },
  [CAMERA_TYPE.TOP]: {
    alpha: 0.903,
    beta: 1.3859,
    radius: 1.3,
    target: { x: -0.008, y: 1.138, z: -0.005 },
    modelTarget:
      "-0.05113019026271415m 1.1480986190598752m 0.12574888578217225m",
    modelOrbit: "6.017931598760977rad 1.587331477389796rad 3.453510481940522m",
    modelFov: "14.332260360543028deg",
    maxCameraOrbit: "auto 120deg 7m",
    type: CAMERA_TYPE.TOP,
  },
  [CAMERA_TYPE.BOTTOM]: {
    alpha: 2.3325,
    beta: 1.578,
    radius: 1.5391,
    target: { x: 0.001, y: 0.546, z: -0.076 },
    modelTarget:
      "0.02565418693008059m 0.4238067769174727m -0.010497652201523877m",
    modelOrbit:
      "-0.44612930167853104rad 1.558409809407251rad 4.482794751518564m",
    modelFov: "17.598deg",
    maxCameraOrbit: "auto 120deg 7m",
    type: CAMERA_TYPE.BOTTOM,
  },
  [CAMERA_TYPE.FACE_SELECTION]: {
    alpha: 1.5366,
    beta: 1.5395,
    radius: 1.8,
    // target: {x: 0.001, y: 1.346, z: -0.076},
    target: { x: 0.001, y: 1.48, z: -0.076 },
    type: CAMERA_TYPE.FACE_SELECTION,
  },
  [CAMERA_TYPE.FACE_SELECTION_FEMALE]: {
    alpha: 1.5366,
    beta: 1.5395,
    radius: 1.6,
    target: { x: 0.001, y: 1.29, z: -0.076 },
    type: CAMERA_TYPE.FACE_SELECTION_FEMALE,
  },
  [CAMERA_TYPE.SHOES]: {
    alpha: 0.2,
    beta: 1.181,
    radius: 1.07,
    fov: 0.8,
    target: { x: 0.0, y: 0.08, z: 0.0 },
    type: CAMERA_TYPE.SHOES,
  },
  [CAMERA_TYPE.HEATMAP_TOP]: {
    alpha: 0.903,
    beta: 1.3859,
    radius: 1.3,
    target: { x: -0.008, y: 1.138, z: -0.005 },
    type: CAMERA_TYPE.HEATMAP_TOP,
  },
  [CAMERA_TYPE.HEATMAP_BOTTOM]: {
    alpha: 2.3325,
    beta: 1.578,
    radius: 1.5391,
    target: { x: 0.001, y: 0.546, z: -0.076 },
    type: CAMERA_TYPE.HEATMAP_BOTTOM,
  },
  enamor: {
    [CAMERA_TYPE.BODY]: {
      alpha: 1.16,
      beta: 1.57,
      radius: 0.92,
      fov: 0.8,
      target: { x: -0.008, y: 1.205, z: -0.005 },
      modelTarget: "0.01m 1.22m 0m",
      modelOrbit: "-30.04deg 90.41deg 2.8m",
      modelFov: "13deg",
      maxCameraOrbit: "auto 120deg 3.5m",
      minCameraOrbit: "auto 60deg 1m",
      type: CAMERA_TYPE.BODY,
    },
    [CAMERA_TYPE.VIEW_MODE]: {
      alpha: 1.16,
      beta: 1.57,
      radius: 0.92,
      fov: 0.8,
      target: { x: -0.008, y: 1.205, z: -0.005 },
      modelTarget: "0.01m 1.22m 0m",
      modelOrbit: "-30.04deg 90.41deg 2.8m",
      modelFov: "13deg",
      maxCameraOrbit: "auto 120deg 3.5m",
      minCameraOrbit: "auto 60deg 1m",
      type: CAMERA_TYPE.VIEW_MODE,
    },
    // [CAMERA_TYPE.VIEW_MODE]: {
    //   alpha: 1.16,
    //   beta: 1.57,
    //   radius: 0.92,
    //   fov: 0.8,
    //   target: { x: -0.008, y: 1.205, z: -0.005 },
    //   modelTarget: "0.01m 1.28m 0m",
    //   modelOrbit: "-30.04deg 90.41deg 2.7m",
    //   modelFov: "13deg",
    //   maxCameraOrbit: "auto 120deg 3.5m",
    //   type: CAMERA_TYPE.VIEW_MODE,
    // },
    [CAMERA_TYPE.WELCOME_SCREEN]: {
      alpha: 1.16,
      beta: 1.57,
      radius: 0.92,
      fov: 0.8,
      target: { x: -0.008, y: 1.205, z: -0.005 },
      modelTarget: "0.01m 1.22m 0m",
      modelOrbit: "-30.04deg 90.41deg 2.8m",
      modelFov: "13deg",
      maxCameraOrbit: "auto 120deg 3.5m",
      minCameraOrbit: "auto 60deg 1m",
      type: CAMERA_TYPE.WELCOME_SCREEN,
    },
  },
  fila: {
    [CAMERA_TYPE.BODY]: {
      modelTarget: "auto auto auto",
      modelOrbit: "45deg auto 14m",
      modelFov: "90deg",
      maxCameraOrbit: "auto auto 18m",
      minCameraOrbit: "auto 60deg 5m",
      type: CAMERA_TYPE.BODY,
    },
    [CAMERA_TYPE.VIEW_MODE]: {
      modelTarget: "auto auto auto",
      modelOrbit: "45deg auto 14m",
      modelFov: "90deg",
      maxCameraOrbit: "auto auto 18m",
      minCameraOrbit: "auto 60deg 5m",
      type: CAMERA_TYPE.VIEW_MODE,
    },
    [CAMERA_TYPE.WELCOME_SCREEN]: {
      modelTarget: "auto auto auto",
      modelOrbit: "45deg auto 14m",
      modelFov: "90deg",
      maxCameraOrbit: "auto auto 18m",
      minCameraOrbit: "auto 60deg 5m",
      type: CAMERA_TYPE.WELCOME_SCREEN,
    },
    [CAMERA_TYPE.SHOES]: {
      modelTarget: "auto auto auto",
      modelOrbit: "45deg auto 14m",
      modelFov: "90deg",
      maxCameraOrbit: "auto auto 18m",
      minCameraOrbit: "auto 60deg 5m",
      type: CAMERA_TYPE.SHOES,
    },
  },
  fef: {
    [CAMERA_TYPE.BODY]: {
      alpha: 1.16,
      beta: 1.57,
      radius: 0.92,
      fov: 0.8,
      target: { x: -0.008, y: 1.205, z: -0.005 },
      modelTarget: "0.01m 1.22m 0m",
      modelOrbit: "-30.04deg 90.41deg 2.8m",
      modelFov: "13deg",
      maxCameraOrbit: "auto 120deg 3.5m",
      type: CAMERA_TYPE.BODY,
    },
    [CAMERA_TYPE.VIEW_MODE]: {
      alpha: 1.16,
      beta: 1.57,
      radius: 0.92,
      fov: 0.8,
      target: { x: -0.008, y: 1.205, z: -0.005 },
      modelTarget: "0.01m 1.22m 0m",
      modelOrbit: "-30.04deg 90.41deg 2.8m",
      modelFov: "13deg",
      maxCameraOrbit: "auto 120deg 3.5m",
      type: CAMERA_TYPE.VIEW_MODE,
    },
    // [CAMERA_TYPE.VIEW_MODE]: {
    //   alpha: 1.16,
    //   beta: 1.57,
    //   radius: 0.92,
    //   fov: 0.8,
    //   target: { x: -0.008, y: 1.205, z: -0.005 },
    //   modelTarget: "0.01m 1.28m 0m",
    //   modelOrbit: "-30.04deg 90.41deg 2.7m",
    //   modelFov: "13deg",
    //   maxCameraOrbit: "auto 120deg 3.5m",
    //   type: CAMERA_TYPE.VIEW_MODE,
    // },
    [CAMERA_TYPE.WELCOME_SCREEN]: {
      alpha: 1.16,
      beta: 1.57,
      radius: 0.92,
      fov: 0.8,
      target: { x: -0.008, y: 1.205, z: -0.005 },
      modelTarget: "0.01m 1.22m 0m",
      modelOrbit: "-30.04deg 90.41deg 2.8m",
      modelFov: "13deg",
      maxCameraOrbit: "auto 120deg 3.5m",
      type: CAMERA_TYPE.WELCOME_SCREEN,
    },
  },
  indianterrain: {
    [CAMERA_TYPE.BODY]: {
      alpha: 0.966,
      beta: 1.5395,
      radius: 2.75,
      fov: 0.85,
      target: { x: 0.0, y: 0.63, z: 0.0 },
      type: CAMERA_TYPE.BODY,
    },
    [CAMERA_TYPE.VIEW_MODE]: {
      alpha: 0.966,
      beta: 1.5395,
      radius: 2.75,
      fov: 0.75,
      target: { x: 0.0, y: 0.8, z: 0.0 },
      type: CAMERA_TYPE.VIEW_MODE,
    },
    [CAMERA_TYPE.WELCOME_SCREEN]: {
      alpha: 0.966,
      beta: 1.5395,
      radius: 2.75,
      fov: 0.85,
      target: { x: 0.0, y: 0.63, z: 0.0 },
      type: CAMERA_TYPE.WELCOME_SCREEN,
    },
    [CAMERA_TYPE.TOP]: {
      alpha: 0.903,
      beta: 1.3859,
      radius: 1.3,
      target: { x: -0.008, y: 1.138, z: -0.005 },
      type: CAMERA_TYPE.TOP,
    },
    [CAMERA_TYPE.BOTTOM]: {
      alpha: 2.3325,
      beta: 1.578,
      radius: 1.5391,
      target: { x: 0.001, y: 0.546, z: -0.076 },
      type: CAMERA_TYPE.BOTTOM,
    },
    [CAMERA_TYPE.FACE_SELECTION]: {
      alpha: 1.5366,
      beta: 1.5395,
      radius: 1.8,
      // target: {x: 0.001, y: 1.346, z: -0.076},
      target: { x: 0.001, y: 1.48, z: -0.076 },
      type: CAMERA_TYPE.FACE_SELECTION,
    },
    [CAMERA_TYPE.FACE_SELECTION_FEMALE]: {
      alpha: 1.5366,
      beta: 1.5395,
      radius: 1.6,
      target: { x: 0.001, y: 1.29, z: -0.076 },
      type: CAMERA_TYPE.FACE_SELECTION_FEMALE,
    },
    [CAMERA_TYPE.SHOES]: {
      alpha: 0.2,
      beta: 1.181,
      radius: 1.07,
      fov: 0.8,
      target: { x: 0.0, y: 0.08, z: 0.0 },
      type: CAMERA_TYPE.SHOES,
    },
    [CAMERA_TYPE.HEATMAP_TOP]: {
      alpha: 0.903,
      beta: 1.3859,
      radius: 1.3,
      target: { x: -0.008, y: 1.138, z: -0.005 },
      type: CAMERA_TYPE.HEATMAP_TOP,
    },
    [CAMERA_TYPE.HEATMAP_BOTTOM]: {
      alpha: 2.3325,
      beta: 1.578,
      radius: 1.5391,
      target: { x: 0.001, y: 0.546, z: -0.076 },
      type: CAMERA_TYPE.HEATMAP_BOTTOM,
    },
  },
};

// export const CAMERA_MODE_ASSET = {
//   Body: {
//     alpha: 1.128,
//     beta: 1.515,
//     radius: 2.75,
//     fov: 0.8,
//     target: { x: 0.0, y: 0.8, z: 0.0 },
//     type: 'Body'
//   },
//   Top: {
//     alpha: 1.5708,
//     beta: 1.2566,
//     // radius: 1.5801,
//     radius: 0.3000,
//     fov: 0.8,
//     target: { x: 0.0, y: 1.16, z: -0.10 },
//     type: 'Top'
//   },
//   Bottom: {
//     alpha: 1.5539,
//     beta: 1.2474,
//     // radius: 1.035,
//     radius: 0.3000,
//     fov: 0.8,
//     target: { x: 0.0, y: 0.65, z: 0.05 },
//     type: 'Bottom'
//   },
//   Foot: {
//     alpha: 1.5783,
//     beta: 1.181,
//     radius: 1.07,
//     fov: 0.8,
//     target: { x: 0.00, y: 0.08, z: 0.00 },
//     type: 'Foot'
//   }
// }

export const CAMERA_MODE_ASSET = {
  Body: {
    alpha: 1.128,
    beta: 1.515,
    radius: 2.75,
    fov: 0.82,
    target: { x: 0.0, y: 0.8, z: 0.0 },
    type: "Body",
  },
  Top: {
    alpha: 1.5708,
    beta: 1.2566,
    radius: 1.5801,
    fov: 0.8,
    target: { x: 0.0, y: 1.16, z: -0.1 },
    type: "Top",
  },
  Bottom: {
    alpha: 1.5539,
    beta: 1.2474,
    radius: 1.035,
    fov: 0.8,
    target: { x: 0.0, y: 0.65, z: 0.05 },
    type: "Bottom",
  },
  Foot: {
    alpha: 1.5783,
    beta: 1.181,
    radius: 1.07,
    fov: 0.8,
    target: { x: 0.0, y: 0.08, z: 0.0 },
    type: "Foot",
  },
};

export const HAIR_STYLES = {
  female: {
    Original: {
      name: "Original",
      path: "",
      gender: "female",
      thumbnailImage: "",
    },
    PonyTailHair: {
      name: "PonyTailHair",
      path: "/hairs/female/onlyPonyTailHair.glb",
      gender: "female",
      thumbnailImage: F1,
    },
    LooseHair: {
      name: "LooseHair",
      path: "/hairs/female/onlyLooseHair.glb",
      gender: "female",
      thumbnailImage: F2,
    },
    BraidedHair: {
      name: "BraidedHair",
      path: "/hairs/female/onlyBraidedHair.glb",
      gender: "female",
      thumbnailImage: F3,
    },
  },
  male: {
    Original: {
      name: "Original",
      path: "",
      gender: "male",
      thumbnailImage: "",
    },
    PompadourHair: {
      name: "PompadourHair",
      path: "/hairs/male/onlyPompadourHair2.glb",
      gender: "male",
      thumbnailImage: M1,
    },
  },
};

export const TOOLTIP_TEXT = {
  Personalise: "Create your twin",
  DefaultPersonalise: "Create {gender} avatar",
  // Logout: "Click to log out",
  // Login: "Click to Log in",
  CheckFit: "Check product fit",
  // Background: "Click to change background",
  Hairs: "Try different hair styles",
  // Camera: "Change camera mode",
  // AddToCart: "Add items to cart",
};

export const LIGHT_TYPES = {
  KEY_LIGHT: "directionalKeyLight",
  FILL_LIGHT: "directionalFillLight",
  BACK_LIGHT: "directionalBackLight",
  POINT_LIGHT_1: "pointLight1",
  POINT_LIGHT_2: "pointLight2",
  POINT_LIGHT_3: "pointLight3",
  POINT_LIGHT_4: "pointLight4",
  AMBIENT_LIGHT: "ambientLight",
  AREA_LIGHT_1: "areaLight1",
  AREA_LIGHT_2: "areaLight2",
  AREA_LIGHT_3: "areaLight3",
  AREA_LIGHT_4: "areaLight4",
};

export const LIGHT_SETTING_TYPES = {
  POINT: "point",
  DIRECTIONAL: "directional",
  POINT_AMBIENT: "pointAmbient",
  AREA: "area",
  ENV_LIGHT: "env",
};

export const FEATURE_FLAGS = {
  default: {
    heatmap: true,
    productFeatures: false,
    faceSelection: true,
    hairsSelection: true,
    cameraActions: true,
    hideFaceImg: false,
    hideFaceCustomisation: false,
    showShoeCamera: true,
    showViewMode: true,
  },
  indianterrain: {
    heatmap: true,
    productFeatures: false,
    faceSelection: true,
    hairsSelection: true,
    cameraActions: true,
    hideFaceImg: false,
    showShoeCamera: false,
    showViewMode: true,
  },
  enamor: {
    heatmap: false,
    productFeatures: true,
    faceSelection: false,
    hairsSelection: false,
    cameraActions: false,
    hideFaceImg: false,
    hideFaceCustomisation: false,
    showShoeCamera: false,
    showViewMode: true,
  },
  fef: {
    heatmap: false,
    productFeatures: true,
    faceSelection: false,
    hairsSelection: false,
    cameraActions: false,
    hideFaceImg: false,
    hideFaceCustomisation: false,
    showShoeCamera: false,
    showViewMode: true,
  },
  rarerabbit: {
    heatmap: true,
    productFeatures: false,
    faceSelection: true,
    hairsSelection: false,
    cameraActions: true,
    hideFaceImg: true,
    hideFaceCustomisation: false,
    showShoeCamera: true,
    showViewMode: true,
  },
  stylox: {
    heatmap: true,
    productFeatures: false,
    faceSelection: false,
    hairsSelection: false,
    cameraActions: true,
    hideFaceImg: true,
    hideFaceCustomisation: true,
    showShoeCamera: false,
    showViewMode: true,
  },
  etail: {
    heatmap: true,
    productFeatures: false,
    faceSelection: false,
    hairsSelection: false,
    cameraActions: true,
    hideFaceImg: true,
    hideFaceCustomisation: true,
    showShoeCamera: false,
    showViewMode: true,
  },
  revolve: {
    heatmap: true,
    productFeatures: false,
    faceSelection: false,
    hairsSelection: false,
    cameraActions: true,
    hideFaceImg: true,
    hideFaceCustomisation: true,
    showShoeCamera: false,
    showViewMode: true,
  },
  retrofete: {
    heatmap: true,
    productFeatures: false,
    faceSelection: false,
    hairsSelection: false,
    cameraActions: true,
    hideFaceImg: true,
    hideFaceCustomisation: true,
    showShoeCamera: false,
    showViewMode: true,
  },
  gap: {
    heatmap: true,
    productFeatures: false,
    faceSelection: false,
    hairsSelection: false,
    cameraActions: true,
    hideFaceImg: true,
    hideFaceCustomisation: true,
    showShoeCamera: false,
    showViewMode: true,
  },
  eberjay: {
    heatmap: true,
    productFeatures: false,
    faceSelection: false,
    hairsSelection: false,
    cameraActions: true,
    hideFaceImg: true,
    hideFaceCustomisation: true,
    showShoeCamera: false,
    showViewMode: true,
  },
  fila: {
    heatmap: false,
    productFeatures: false,
    faceSelection: false,
    hairsSelection: false,
    cameraActions: false,
    hideFaceImg: true,
    hideFaceCustomisation: true,
    showShoeCamera: true,
    showViewMode: false,
  },
};

export const DOPPLR_TEXT = {
  default: {
    BACKGROUND: "Backgrounds",
    BACKGROUND_HEADING: "Lets see how you look in different settings",
    FACE: "Face",
    HAIR: "Hair",
    HAIR_HEADING: "Let's see how you look in different hair styles",
    MEASUREMENTS: "Measurements",
    ADD_TO_CART: "Add to cart",
    VIEW_FEATURES: "View Features",
    CUSTOMIZE: "Customize",
    TOP: "Top",
    BOTTOM: "Bottom",
    RELATED_PRODUCTS: "Click here to see related products",
  },
};

export const tempPropertyChange = {
  missChase: {
    // '1A_0': [
    //   'Cloth_primitive6',
    //   'Cloth_primitive3',
    //   'Cloth_primitive18',
    //   'Cloth_primitive0',
    //   'Cloth_primitive15',
    // ],
    // '1B_0': [
    //   'Cloth_primitive28',
    //   'Cloth_primitive34',
    //   'Cloth_primitive31',
    //   'Cloth_primitive14',
    //   'Cloth_primitive9',
    //   'Cloth_primitive14',
    //   'Cloth_primitive19',
    //   'Cloth_primitive3',
    //   'Cloth_primitive25',
    //   'Cloth_primitive11',
    //   'Cloth_primitive20',
    //   'Cloth_primitive4',
    //   'Cloth_primitive17',
    //   'Cloth_primitive22',
    //   'Cloth_primitive23',
    //   'Cloth_primitive35',
    //   'Cloth_primitive29',
    //   'Cloth_primitive32',
    //   'Cloth_primitive6',
    // ]
  },
};

export const VIEWER_STATE_KEYS = {
  DRAPE_CLOTHES: "drapeClothes",
  SHOW_HEATMAP_INFO: "showHeatmapInfo",
  SHOW_FEATURES: "showFeatures",
  VIEW_MODE: "viewMode",
  SHOW_SUMMARY: "showSummary",
  SHARE_AVATAR: "shareAvatar",
  SHOW_SHARE_OPTION: "showShareOption",
  SHOE_VIEW_MODE: "shoeViewMode",
  SHOW_REPLACE_AVATAR: "showReplaceAvatar",
  SHOW_BODY_VISUALISER: "showBodyVisualiser",
  SHOW_HEATMAP: "showHeatmap",
  HIDE_FLOATING_BAR: "hideFloatingBar",
  SHOW_ENVIRONMENTS: "showEnvironments",
  SHOW_VARIATIONS: "showVariations",
  SHOW_HAIR_SELECTOR: "showHairSelector",
  SHOW_AVATAR_FORM: "showAvatarForm",
  SHOW_CATALOG_LIST: "showCatalogList",
  ADD_TO_CART: "addToCart",
  SHOW_MODEL_VIEWER: "showModelViewer",
};

export const LOADER_STATE_KEYS = {
  LOADING: "loading",
  REPLACE_AVATAR_LOADER: "replaceAvatarLoader",
  HEATMAP_LOADING: "heatmapLoading",
  SCENE_LOADING: "sceneLoading",
};
